/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Household_Registered_ToastInputs */

const fr_household_registered_toast = /** @type {(inputs: Household_Registered_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Inscription de ${i?.name} validée`)
};

/**

* @param {Household_Registered_ToastInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const household_registered_toast = /** @type {((inputs: Household_Registered_ToastInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Household_Registered_ToastInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_household_registered_toast(inputs)
});